import CircularProgress from '@mui/material/CircularProgress';
import { Button } from '@mui/material';
import Cancel from '@assets/circle-cancel.svg';
import classes from './index.module.css';

/**
 * 上传组件
 */
export const Upload = ({
  /** 需要上传的文件列表 */
  files,
  /** 允许上传的文件类型 */
  accept,
  /** disable */
  disable,
  /** input 的 ref */
  inputValue,
  /** 选择文件后的 change 事件 */
  handleChange,
  /** 删除文件事件 */
  deleteFile,
  /** children */
  children,
  style = {},
}) => (
  <>
    {/* 上传区域 */}
    <section className={classes.content} style={style}>
      <Button
        component="label"
        style={{ textTransform: 'none', width: '100%' }}
        className={classes.upload_block}
      >
        <input
          ref={inputValue}
          hidden
          multiple
          accept={accept?.join(', ') || '*'}
          type="file"
          onChange={handleChange}
          disabled={disable}
        />
        <section className={classes.upload_btn}>Add files</section>
        <section className={classes.upload_text}>{children}</section>
      </Button>
      <section className={classes.file_list}>
        {files.map((file, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <section className={classes.file} key={`${file.name}_${index}`}>
            {file.name}
            {file.isLoading
              ? <CircularProgress size={12} className={classes.loading_btn} />
              : (
                <section className={classes.delete_btn} onClick={() => deleteFile(index)}>
                  <img
                    src={Cancel}
                    className={classes.cancel_icon}
                    alt=""
                  />
                </section>
              )}
          </section>
        ))}
      </section>
    </section>
  </>
);
